var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../../config/request';
export const fetchCheckPay = createAsyncThunk('check-payment/fetch', (_, thunkApi) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { data } = yield request('/dekanat/check-payment', 'POST');
        // const filterWs: IWs[] = data.filter(item => item.id_ws != 3)
        return data;
    }
    catch (e) {
        return thunkApi.rejectWithValue('Ошибка');
    }
}));
